<template>
    <div class="case-popup" :class="'case-popup--'+colorTheme">

        <div class="case-popup__close-btn close-button" :class="'close-button--'+colorTheme" @click="$emit('close')">CLOSE</div>

        <div class="case-popup__window">

            <div class="case-popup__header">
                <div class="case-popup__heading">{{challengeCase.heading}}</div>
                <div class="case-popup__subheading">{{challengeCase.sector}}</div>
            </div>

            <div class="case-popup__navigation">
                <div v-if="showChallenge" class="case-popup__nav-button" @click="currentTab = 'challenge'" :class="{'case-popup__nav-button--selected': currentTab === 'challenge'}">{{tabChallengeLabel}}</div>
                <div v-if="showSolution" class="case-popup__nav-button" @click="currentTab = 'solution'" :class="{'case-popup__nav-button--selected': currentTab === 'solution'}">{{tabSolutionLabel}}</div>
                <div v-if="showResult" class="case-popup__nav-button" @click="currentTab = 'result'" :class="{'case-popup__nav-button--selected': currentTab === 'result'}">{{tabResultLabel}}</div>
                <div v-if="showCompany" class="case-popup__nav-button" @click="currentTab = 'company'" :class="{'case-popup__nav-button--selected': currentTab === 'company'}">{{tabCompanyLabel}}</div>
                <div v-if="showLocalPartner" class="case-popup__nav-button" @click="currentTab = 'localPartner'" :class="{'case-popup__nav-button--selected': currentTab === 'localPartner'}">{{tabLocalPartnerLabel}}</div>
            </div>


            <div v-show="currentTab === 'challenge'" class="case-popup__tab case-popup__tab--challenge">

                <div class="case-popup__main-media">
                    <CaseSlideshow :slidesData="challengeCase.challengesMainMedia" @selectVideo="selectVideo"></CaseSlideshow>
                </div>

                <div v-if="challengeCase.challengesExtraImage" class="case-popup__extra-image" :class="{'case-popup__extra-image--contain': challengeCase.challengesExtraImageContain}">
                    <PreloadedImage :src="imageUrl(challengeCase.challengesExtraImage)"/>
                </div>

                <div class="case-popup__main-text">
                    <ScrollBar class="case-popup__main-scroll">
                        <div v-html="challengeCase.challenges"></div>
                        <div class="case-popup__main-source" v-html="challengeCase.challengesSource"></div>
                    </ScrollBar>
                </div>

                <div v-if="challengeCase.challengesInfoBox" class="case-popup__info-box" :class="'case-popup__info-box--'+challengeCase.challengesInfoBoxType">
                    <ScrollBar class="case-popup__info-box-scroll">
                        <div v-if="challengeCase.challengesInfoBoxHeading" class="case-popup__info-box-heading">{{challengeCase.challengesInfoBoxHeading}}</div>
                        <div class="case-popup__info-box-content" v-html="challengeCase.challengesInfoBox"></div>
                    </ScrollBar>
                </div>

            </div>

            <div v-show="currentTab === 'solution'" class="case-popup__tab case-popup__tab--solution">

                <div class="case-popup__main-media">
                    <CaseSlideshow :slidesData="challengeCase.solutionsMainMedia" @selectVideo="selectVideo"></CaseSlideshow>
                </div>

                <div v-if="challengeCase.solutionsExtraImage" class="case-popup__extra-image" :class="{'case-popup__extra-image--contain': challengeCase.solutionsExtraImageContain}">
                    <img :src="imageUrl(challengeCase.solutionsExtraImage)"/>
                </div>

                <div class="case-popup__main-text">
                    <ScrollBar class="case-popup__main-scroll">
                        <div v-html="challengeCase.solutions"></div>
                        <div class="case-popup__main-source" v-html="challengeCase.solutionsSource"></div>
                    </ScrollBar>
                </div>

                <div v-if="challengeCase.solutionsInfoBox" class="case-popup__info-box" :class="'case-popup__info-box--'+challengeCase.solutionsInfoBoxType">
                    <ScrollBar class="case-popup__info-box-scroll">
                        <div v-if="challengeCase.solutionsInfoBoxHeading" class="case-popup__info-box-heading">{{challengeCase.solutionsInfoBoxHeading}}</div>
                        <div class="case-popup__info-box-content" v-html="challengeCase.solutionsInfoBox"></div>
                    </ScrollBar>
                </div>

            </div>

            <div v-show="currentTab === 'result'" class="case-popup__tab case-popup__tab--result">

                <div class="case-popup__main-media">
                    <CaseSlideshow :slidesData="challengeCase.resultsMainMedia" @selectVideo="selectVideo"></CaseSlideshow>
                </div>

                <div v-if="challengeCase.resultsExtraImage" class="case-popup__extra-image" :class="{'case-popup__extra-image--contain': challengeCase.resultsExtraImageContain}">
                    <img :src="imageUrl(challengeCase.resultsExtraImage)"/>
                </div>

                <div class="case-popup__main-text">
                    <ScrollBar class="case-popup__main-scroll">
                        <div v-html="challengeCase.results"></div>
                        <div class="case-popup__main-source" v-html="challengeCase.resultsSource"></div>
                    </ScrollBar>
                </div>

                <div v-if="challengeCase.resultsInfoBox" class="case-popup__info-box" :class="'case-popup__info-box--'+challengeCase.resultsInfoBoxType">
                    <ScrollBar class="case-popup__info-box-scroll">
                        <div v-if="challengeCase.resultsInfoBoxHeading" class="case-popup__info-box-heading">{{challengeCase.resultsInfoBoxHeading}}</div>
                        <div class="case-popup__info-box-content" v-html="challengeCase.resultsInfoBox"></div>
                    </ScrollBar>
                </div>


            </div>

            <div v-show="currentTab === 'company'" class="case-popup__tab case-popup__tab--company">

                <div class="case-popup__main-media">
                    <CaseSlideshow :slidesData="challengeCase.companyMainMedia" @selectVideo="selectVideo"></CaseSlideshow>
                </div>

                <div v-if="challengeCase.companyExtraImage" class="case-popup__extra-image" :class="{'case-popup__extra-image--contain': challengeCase.companyExtraImageContain}">
                    <img :src="imageUrl(challengeCase.companyExtraImage)"/>
                </div>

                <div class="case-popup__main-text">
                    <ScrollBar class="case-popup__main-scroll">
                        <div v-html="challengeCase.aboutTheCompany"></div>
                        <div class="case-popup__main-source" v-html="challengeCase.aboutTheCompanySource"></div>
                    </ScrollBar>
                </div>

                <div v-if="challengeCase.companyInfoBox" class="case-popup__info-box" :class="'case-popup__info-box--'+challengeCase.companyInfoBoxType">
                    <ScrollBar class="case-popup__info-box-scroll">
                        <div v-if="challengeCase.companyInfoBoxHeading" class="case-popup__info-box-heading">{{challengeCase.companyInfoBoxHeading}}</div>
                        <div class="case-popup__info-box-content" v-html="challengeCase.companyInfoBox"></div>
                    </ScrollBar>
                </div>

            </div>

            <div v-show="currentTab === 'localPartner'" class="case-popup__tab case-popup__tab--local-partner">

                <div class="case-popup__main-media">
                    <CaseSlideshow :slidesData="challengeCase.localPartnerMainMedia" @selectVideo="selectVideo"></CaseSlideshow>
                </div>

                <div v-if="challengeCase.localPartnerExtraImage" class="case-popup__extra-image" :class="{'case-popup__extra-image--contain': challengeCase.localPartnerExtraImageContain}">
                    <img :src="imageUrl(challengeCase.localPartnerExtraImage)"/>
                </div>

                <div class="case-popup__main-text">
                    <ScrollBar class="case-popup__main-scroll">
                        <div v-html="challengeCase.localPartnerText"></div>
                        <div class="case-popup__main-source" v-html="challengeCase.localPartnerSource"></div>
                    </ScrollBar>
                </div>

                <div v-if="challengeCase.companyInfoBox" class="case-popup__info-box" :class="'case-popup__info-box--'+challengeCase.localPartnerInfoBoxType">
                    <ScrollBar class="case-popup__info-box-scroll">
                        <div v-if="challengeCase.localPartnerInfoBoxHeading" class="case-popup__info-box-heading">{{challengeCase.localPartnerInfoBoxHeading}}</div>
                        <div class="case-popup__info-box-content" v-html="challengeCase.localPartnerInfoBox"></div>
                    </ScrollBar>
                </div>

            </div>

        </div>

        <div v-if="selectedVideo" class="video-overlay">
            <div class="video-overlay__close-btn close-button" :class="'close-button--'+colorTheme" @click="selectedVideo = null"></div>

            <video
                v-if="!selectedVideo.youtubeURL"
                id="FullscreenVideo__video"
                autoplay
                controls
                playsinline
                webkit-playsinline
                type="video/mp4"
                :src="getLocalVideoSrc(selectedVideo.videoFile.src)"
                :poster="img"
                @contextmenu.prevent=""></video>

            <iframe
                v-if="selectedVideo.youtubeURL"
                id="FullscreenVideo__video_youtube" :src="'https://www.youtube.com/embed/'+getYoutubeIdFromLink(selectedVideo.youtubeURL)+'?modestbranding=1&showinfo=0&autoplay=1&autohide=1&rel=0'" @contextmenu.prevent="" frameborder="0"
                allowfullscreen="allowfullscreen"
                mozallowfullscreen="mozallowfullscreen" 
                msallowfullscreen="msallowfullscreen" 
                oallowfullscreen="oallowfullscreen" 
                webkitallowfullscreen="webkitallowfullscreen"></iframe>

        </div>

    </div>
</template>


<script>
import CaseSlideshow from '@/components/CaseSlideshow.vue';
import config from '@/config.js';
import ScrollBar from '@/components/ScrollBar';
import PreloadedImage from '@/components/PreloadedImage.vue';

export default {
  name: 'CaseOverlay',
  components: {
      CaseSlideshow: CaseSlideshow,
      ScrollBar: ScrollBar,
      PreloadedImage: PreloadedImage
  },
  props: {
      challengeCase: Object,
      colorTheme: String,
  },
  data()
  {
    return {
        currentTab: 'challenge',
        selectedVideo: null
    }
  },
  computed: {
    isYoutubeVideo() {
        return this.youtube !== ''
    },
    tabChallengeLabel()
    {
        return (this.challengeCase.tab1Label) ? this.challengeCase.tab1Label : 'Challenge';
    },
    tabSolutionLabel()
    {
        return (this.challengeCase.tab2Label) ? this.challengeCase.tab2Label : 'Solution';
    },
    tabResultLabel()
    {
        return (this.challengeCase.tab3Label) ? this.challengeCase.tab3Label : 'Result';
    },
    tabCompanyLabel()
    {
        return (this.challengeCase.tab4Label) ? this.challengeCase.tab4Label : 'Company';
    },
    tabLocalPartnerLabel()
    {
        return (this.challengeCase.tab5Label) ? this.challengeCase.tab5Label : 'Local Partner';
    },
    showChallenge()
    {
        return (this.challengeCase.challengesMainMedia &&  this.challengeCase.challenges)
    },
    showSolution()
    {
        return (this.challengeCase.solutionsMainMedia &&  this.challengeCase.solutions)
    },
    showResult()
    {
        return (this.challengeCase.resultsMainMedia &&  this.challengeCase.results)
    },
    showCompany()
    {
        return (this.challengeCase.companyMainMedia &&  this.challengeCase.aboutTheCompany)
    },
    showLocalPartner()
    {
        return (this.challengeCase.localPartnerMainMedia &&  this.challengeCase.localPartnerText)
    }
  },
  methods:
  {
    imageUrl(image)
    {
        var url = config.umbracoMediaPath + image.src;
        return url;
    },
    selectVideo(videoSlideData)
    {
        this.selectedVideo = videoSlideData;
    },
    getYoutubeIdFromLink(link) {
        // NOTE(Mølby): Figure out youtube id.
        var youtubeVideoId = link.split('v=')[1];
        var ampersandPosition = youtubeVideoId.indexOf('&');
        if(ampersandPosition != -1) {
            youtubeVideoId = youtubeVideoId.substring(0, ampersandPosition);
        }

        return youtubeVideoId;            
    },
    getLocalVideoSrc(src)
    {
        return config.umbracoMediaPath + src;
    }
  }
}
</script>